/**
*功能名称：渲染节点
*创 建 人：弋强
*日    期：2022/05/06 17:29:40
*/
import { ApproveData, BaseApprove } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import filterTool from "./util/filterTool";
import { getDecorator } from "./decorator";
import { IDecorator, INmis } from "./types";
import { NmisApi } from "./api/nmisApi";
import { fromJS } from "immutable";

@Component({
    components: {

    }
})
export default class Nmis extends BaseApprove implements INmis {
    init(approveData: ApproveData, actReFlow: any) {
        const method = this.getMethod("approval_view_init");
        if (!this.isNull(method)) {
            method({
                sender: this,
                param: {
                    event: {
                        data: {
                            approveData: approveData,
                            actReFlow: actReFlow
                        }
                    }
                }
            });
        }
    }
    openModal(): void {
        const method = this.getMethod("approval_view_openModal");
        if (!this.isNull(method)) {
            method({
                sender: this,
                param: {
                    event: {
                        data: {}
                    }
                }
            });
        }
    }
    closeModal(): void {
        const method = this.getMethod("approval_view_closeModal");
        if (!this.isNull(method)) {
            method({
                sender: this,
                param: {
                    event: {
                        data: {}
                    }
                }
            });
        }
    }
    pass(isEnd: boolean, approveData: ApproveData) {
        const method = this.getMethod("approval_view_pass");
        if (!this.isNull(method)) {
            method({
                sender: this,
                param: {
                    event: {
                        data: {
                            isEnd: isEnd,
                            approveData: approveData
                        }
                    }
                }
            });
        }
    }
    return(isStart: boolean, approveData: ApproveData) {
        const method = this.getMethod("approval_view_failure");
        if (!this.isNull(method)) {
            method({
                sender: this,
                param: {
                    event: {
                        data: {
                            isStart: isStart,
                            approveData: approveData
                        }
                    }
                }
            });
        }
    }

    //#region 变量定义区

    /**
     * 架构
     */
    @Prop({ default: () => ({}) })
    schemaNode: any;

    /**
     * 样式表
     */
    @Prop({ default: "" })
    styleContent?: string;

    /**
     * 方法数组
     */
    @Prop({ default: () => ({}) })
    methodObj?: any;

    /**
     * 父对象
     */
    @Prop({ default: () => (undefined) })
    parentNmis: any;

    /**
     * 父数据
     */
    @Prop({ default: () => ({}) })
    parentData: any;

    /**
     * 父元素修改索引
     */
    @Prop({ default: 0 })
    parentChangeIndex?: number;

    /**
     * 组件Id映射
     */
    @Prop({ default: () => ({}) })
    componentIdMap?: any;

    /**
     * 是否为编辑模式
     */
    @Prop({ default: false })
    isEditor?: boolean;

    /**
     * 项目Id
     */
    @Prop({ default: 0 })
    projectId?: number;

    /**
     * 子系统Id
     */
    @Prop({ default: 0 })
    childsysId?: number;

    /**
     * 开发环境
     */
    @Prop({ default: 'dev' })
    devProd?: string;

    changeIndex: number = 1;
    currentData: any = {}; // 当前对象数据 父对象数据通过 __super 获取
    openData: any = {}; // 展开后的数据
    copySchemaNode: any; // 用于渲染的schema, 初始时复制schemaNode, 运算表达式后获取表达式的值
    dom: any;
    $vue: any;

    decorator?: IDecorator;
    styleId: string = this.getUniqueCode();

    //#endregion 变量定义区

    //#region 事件定义区

    async mounted() {
        // 3. DOM创建完毕
        this.$vue = this.dom.componentInstance;
        await this.decorator!.inited();

        // 4. 添加样式
        this.createStyle();

        // 5. LoadData
        if (NmisApi.canSendOn(this.copySchemaNode.source, this.openData)) {
            await this.decorator!.loadData();
        }
    }

    created() {
        this.currentData = Object.assign(this.currentData, this.isNull(this.schemaNode.data) ? {} : this.schemaNode.data);
        this.$set(this.currentData, '__super', this.parentData);
        this.copySchemaNode = fromJS(this.schemaNode).toJS();
        this.openData = filterTool.openData(this.currentData);

        if (Object.keys(this.componentIdMap).length == 0) {
            this.componentIdMap["root"] = this;
        }

        // 记录组件和id的关联
        if (!this.isNull(this.copySchemaNode.id)) {
            this.componentIdMap[this.copySchemaNode.id] = this;
        }

        this.decorator = getDecorator(this.copySchemaNode.type); // 初始化装饰器
        this.decorator.created(this);
    }

    //#endregion 事件定义区

    //#region 方法定义区

    @Watch('schemaNode', { immediate: false, deep: true })
    onSchemaNodeChanged(val: any, oldVal: any) {
        this.currentData = Object.assign(this.currentData, this.isNull(this.schemaNode.data) ? {} : this.schemaNode.data);
        this.openData = filterTool.openData(this.currentData);
        this.copySchemaNode = fromJS(this.schemaNode).toJS();
    }

    @Watch('parentChangeIndex', { immediate: false, deep: false })
    onParentChangeIndexChanged(val: any, oldVal: any) {
        this.currentData.__super = this.parentData;
        this.openData = filterTool.openData(this.currentData);
        this.changeIndex += 1;
    }

    @Watch('styleContent', { immediate: false, deep: false })
    onStyleContentChanged(val: any, oldVal: any) {
        this.createStyle();
    }

    createStyle() {
        if (this.isNull(this.styleContent)) {
            return;
        }

        if (this.isNull(this.$vue)) {
            return;
        }

        if (this.isNull(this.$vue.$el)) {
            return;
        }

        // this.componentInstance.$el.parentElement.
        var style = document.getElementById(this.styleId);
        if (style != null) {
            style.remove();
        }

        style = document.createElement('style')
        // style.type = 'text/css';
        style.id = this.styleId;
        style.appendChild(document.createTextNode(this.styleContent!))
        var head = this.$vue.$el.parentElement;
        head.appendChild(style);
    }

    /**
     * 创建Dom
     * @param h 
     * @param body 
     * @param slot 
     * @returns 
     */
    createDom(h, body, slots: any[]) {
        const type = this.copySchemaNode["type"];

        // 1. 初始化装饰器
        this.decorator!.start(this);

        // 2. 将要开始创建DOM
        this.decorator!.beforeInit();

        body = filterTool.autoFilterValue(body, this.openData);

        if (!Array.prototype.isPrototypeOf(body)) {
            body = [body];
        }
        body = slots.concat(body);

        // 4. 创建DOM        
        this.dom = h(type, this.copySchemaNode, filterTool.autoFilterValue(body, this.openData));

        return this.dom;
    }

    /**
     * 创建孩子节点
     * @param h 
     * @param json 
     * @param slotName 
     * @returns 
     */
    createChild(h, json, slotName: string | 'default' = 'default') {
        if (this.isNull(h) || this.isNull(json) || this.isNull(json.type)) {
            return undefined;
        }

        if (!filterTool.doFilterBoolean(json['if'], this.openData)) {
            return undefined;
        }

        const isShow = filterTool.doFilterBoolean(json["show"], this.openData);

        const childDom = h('nmis', {
            props: {
                schemaNode: json,
                parentData: this.currentData,
                parentChangeIndex: this.changeIndex,
                componentIdMap: this.componentIdMap,
                methodObj: this.methodObj,
                parentNmis: this,
                isEditor: this.isEditor,
                projectId: this.projectId,
                childsysId: this.childsysId,
                devProd: this.devProd,
                linkParam: this.linkParam
            },
            slot: slotName,
            style: {
                display: isShow ? "" : "none"
            },
            on: {
                change: (name, value) => {
                    this.$set(this.currentData, name, value);
                }
            }
        });

        return childDom;
    }

    render(h) {
        const body = this.schemaNode["body"];
        const slot = this.schemaNode.slot;

        // 0. slot
        const slotDoms: any[] = [];
        if (!this.isNull(slot)) {
            for (const key in slot) {
                const slotDom = this.createChild(h, slot[key], key);

                if (!this.isNull(slotDom)) {
                    slotDoms.push(slotDom);
                }
            }
        }

        // 1. 渲染节点
        if (this.isNull(body) || typeof (body) == "string") {
            return this.createDom(h, this.isNull(body) ? '' : body, slotDoms);
        }

        // 2. 组织孩子节点Schema
        const bodyDom: any[] = [];
        let bodyJsonArray: any[] = [];
        if (Array.prototype.isPrototypeOf(body)) {
            bodyJsonArray = body;
        } else {
            bodyJsonArray.push(body);
        }

        // 3. 渲染孩子节点
        for (const bodyJson of bodyJsonArray) {

            const childDom = this.createChild(h, bodyJson);

            if (!this.isNull(childDom)) {
                bodyDom.push(childDom);
            }
        }

        // 4. 渲染节点
        return this.createDom(h, bodyDom, slotDoms);
    }

    //#endregion 方法定义区


    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================
    //#region 公开Api定义区

    /**
     * 获取根组件
     * @returns 
     */
    getRootComponent() {
        return this.componentIdMap.root;
    }

    /**
     * 根据组件Id获取组件
     * @param componentId 
     * @returns 
     */
    getComponentById(componentId) {
        if (filterTool.isNull(componentId)) {
            return undefined;
        }

        if (filterTool.isNull(this.componentIdMap[componentId])) {
            return undefined;
        }

        const nmis: Nmis = this.componentIdMap![componentId];
        return nmis;
    }

    /**
     * 获取数据
     * @param componentId 
     * @returns 
     */
    getDataById(componentId) {
        const nmis: Nmis | undefined = this.getComponentById(componentId);
        if (nmis == undefined) {
            return undefined;
        }
        return nmis.currentData;
    }

    /**
     * 设置数据
     * @param componentId 
     * @returns 
     */
    setDataById(componentId, data) {
        const nmis: Nmis | undefined = this.getComponentById(componentId);
        if (nmis == undefined) {
            return;
        }

        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                this.$set(nmis.currentData, key, element);
            }
        }
        nmis.openData = filterTool.openData(nmis.currentData);
        nmis.update();
    }

    /**
     * 设置值
     * @param data 
     */
    setData(data) {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                this.$set(this.currentData, key, element);
            }
        }
        this.openData = filterTool.openData(this.currentData);
        this.update();
    }

    /**
     * 获取值
     * @returns 
     */
    getData() {
        return filterTool.jsonClone(this.currentData);
    }

    /**
     * 更新当前元素
     */
    update() {
        this.changeIndex += 1;
    }

    /**
     * 获取方法体
     * @param methodName 
     * @returns 
     */
    getMethod(methodName) {
        return this.methodObj[methodName];
    }

    /**
     * 通过表名创建Api对象
     * @param tableName 表名
     * @returns 
     */
    createApiByTableName(tableName: string): NmisApi {
        return NmisApi.createApiByTableName(tableName, this.projectId, this.childsysId, this.devProd);
    }
    /**
     * 通过代理名称和控制器名称创建Api对象
     * @param proxyName 代理名称
     * @param controllerName 控制器名称
     * @returns 
     */
    createApiByProxyNameAndControllerName(proxyName: string, controllerName: string): NmisApi {
        return NmisApi.createApiByProxyNameAndControllerName(proxyName, controllerName);
    }
    /**
     * 执行编程设计程序
     * @param programkey 程序Key
     * @param data 参数
     * @returns 
     */
    runAction(programkey, data): Promise<any> {
        return NmisApi.runAction(programkey, data, this.projectId, this.childsysId, this.devProd);
    }

    //#endregion 公开Api定义区
}